import Nullstack from 'nullstack';
export default function IconChartDots2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-dots-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 3v18h18"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "13",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M21 3l-6 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.113 6.65l2.771 3.695"
  }), "   ", Nullstack.element("path", {
    d: "M16 12.5l-5 2"
  }), " ");
}